import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useBundle } from "@/features/bundles/hooks/use-bundle";
import AddEditBundlesForm from "@/features/bundles/ui/bundle-form";
import { HasAccess } from "@/components/common/has-access";
import { Button } from "@/components/ui/button";
import ThreeDotsLoader from "@/components/common/three-dots-loader";

export default function BundleEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: bundle, isLoading, error } = useBundle(id);

  return (
    <HasAccess permission="write">
      <div className="max-w-6xl mx-auto p-6 space-y-4">
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="icon" onClick={() => navigate("..")}>
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <h1 className="text-xl font-semibold">Edit Bundle</h1>
        </div>

        {isLoading ? (
          <div className="flex justify-center py-16">
            <ThreeDotsLoader />
          </div>
        ) : error || !bundle ? (
          <div className="py-12 text-center text-sm text-red-600">
            Failed to load bundle.
          </div>
        ) : (
          <AddEditBundlesForm
            editMode
            initialData={bundle}
            onClose={() => navigate("..")}
          />
        )}
      </div>
    </HasAccess>
  );
}
